import produce from "immer"
import { ASC } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initAccountUserState: types.AccountUserState = {
    accountUserList: null,
    userAccountList: null,

    assignedUsers: {
        userIds: null,
        sortColumn: "firstName",
        sortOrder: ASC,
        filters: {
            status: null,
            search: null,
        },
    },
    notAssignedUsers: {
        userIds: null,
        sortColumn: "firstName",
        sortOrder: ASC,
        filters: {
            status: null,
            search: null,
        },
        selected: null,
    },

    assignedAccounts: {
        accountIds: null,
        sortColumn: "name",
        sortOrder: ASC,
        filters: {
            status: null,
            search: null,
        },
    },
    notAssignedAccounts: {
        accountIds: null,
        sortColumn: "name",
        sortOrder: ASC,
        filters: {
            status: null,
            search: null,
        },
        selected: null,
    },

    reloadAccountUserList: true,
    reloadUserAccountList: true,
}

const accountUserReducer = produce((
    draft: types.AccountUserState = initAccountUserState,
    action: ActionTypes = null,
): types.AccountUserState => {
    switch (action.type) {
        case types.ACCOUNT_USER_LIST:
            draft.accountUserList = {
                ...draft.accountUserList,
                ...action.accountUserList,
            }
            return draft

        case types.USER_ACCOUNT_LIST:
            draft.userAccountList = action.userAccountList
            return draft

            // account users

        case types.ASSIGNED_ACCOUNT_USER_IDS:
            draft.assignedUsers.userIds = action.userIds
            return draft

        case types.ASSIGNED_ACCOUNT_USER_SORT:
            draft.assignedUsers.sortColumn = action.sortColumn
            draft.assignedUsers.sortOrder = action.sortOrder
            return draft

        case types.ASSIGNED_ACCOUNT_USER_FILTERS:
            draft.assignedUsers.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_ACCOUNT_USER_IDS:
            draft.notAssignedUsers.userIds = action.userIds
            return draft

        case types.NOT_ASSIGNED_ACCOUNT_USER_SORT:
            draft.notAssignedUsers.sortColumn = action.sortColumn
            draft.notAssignedUsers.sortOrder = action.sortOrder
            return draft

        case types.NOT_ASSIGNED_ACCOUNT_USER_FILTERS:
            draft.notAssignedUsers.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_ACCOUNT_USER_SELECTED:
            draft.notAssignedUsers.selected = action.selected
            return draft

            // user accounts

        case types.ASSIGNED_USER_ACCOUNT_IDS:
            draft.assignedAccounts.accountIds = action.accountIds
            return draft

        case types.ASSIGNED_USER_ACCOUNT_SORT:
            draft.assignedAccounts.sortColumn = action.sortColumn
            draft.assignedAccounts.sortOrder = action.sortOrder
            return draft

        case types.ASSIGNED_USER_ACCOUNT_FILTERS:
            draft.assignedAccounts.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_USER_ACCOUNT_IDS:
            draft.notAssignedAccounts.accountIds = action.accountIds
            return draft

        case types.NOT_ASSIGNED_USER_ACCOUNT_SORT:
            draft.notAssignedAccounts.sortColumn = action.sortColumn
            draft.notAssignedAccounts.sortOrder = action.sortOrder
            return draft

        case types.NOT_ASSIGNED_USER_ACCOUNT_FILTERS:
            draft.notAssignedAccounts.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_USER_ACCOUNT_SELECTED:
            draft.notAssignedAccounts.selected = action.selected
            return draft

            // load state

        case types.ACCOUNT_USER_RELOAD_LIST:
            draft.reloadAccountUserList = action.value
            return draft

        case types.USER_ACCOUNT_RELOAD_LIST:
            draft.reloadUserAccountList = action.value
            return draft

        default:
            return draft
    }
})
export default accountUserReducer
